import { FC } from 'react';

import { CommunicationInvalidRecipient } from 'types/Communication';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import InvalidRecipientsTableRow from './InvalidRecipientsTableRow';

const InvalidRecipientsTableBody: FC = () => {
  const { data } = useCommunicationDetailsPage();

  const invalidRecipients = data.communication?.invalidRecipients || [];

  const hasData = invalidRecipients?.length > 0;

  const rows = invalidRecipients.map(
    (invalidRecipient: CommunicationInvalidRecipient, index: number) => (
      <InvalidRecipientsTableRow
        key={invalidRecipient._id ?? `invalid-recipient-row-${index}`}
        index={index}
        invalidRecipient={invalidRecipient}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage=""
      noDataColspan={10}
    />
  );
};

export default InvalidRecipientsTableBody;
